import { useSelector } from 'react-redux';
import { SlDropdownMenuOption } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/SlMenu';
import ReduxStore from 'src/types/store/reduxStore';

type DataType = 'brands' | 'category' | 'sub-category';

/**
 * Hook to get formatted data from Redux based on data type
 * @param type The type of data to fetch and format
 * @returns Formatted data for dropdowns
 */
export const useFormattedData = (type: DataType): SlDropdownMenuOption[] => {
  // Using any for now since we don't have access to the RootState type
  const brands = useSelector((state: ReduxStore) => state.brandsFollowing).filter(
    (brand) => brand.id != 1468847 && brand.id != 0
  );

  const categories = useSelector((state: ReduxStore) => state.categories);
  const subCategories = useSelector((state: ReduxStore) => state.subCategories);

  switch (type) {
    case 'brands':
      return brands.map((brand) => ({
        id: brand.name,
        label: brand.name
      }));
    case 'category':
      return categories.map((category) => ({
        id: category.id.toString(),
        label: category.name
      }));
    case 'sub-category':
      return subCategories.map((subCategory) => ({
        id: subCategory.id.toString(),
        label: subCategory.name
      }));
    default:
      return [];
  }
};
